<div class="ng-autocomplete w-100">
  <style>
    .autocomplete-container {
      height: 25px !important;
    }
    .autocomplete-container .input-container input {
      height: 25px !important;
    }
  </style>

    <ng-autocomplete 
      #searchInput
      [class]='classSearch'
      [data]="data"
      [searchKeyword]="keyword"
      placeholder="Buscar tours"
      (selected)='selectSearchTour($event)'
      (inputChanged)='debouncedSearchInput($event)' 
      (inputCleared)='clearedInputSearch()'                              
      (closed)='closedSearchPanel()'                              
      [itemTemplate]="itemTemplate"
      [notFoundTemplate]="notFoundTemplate"
      [disabled]="isAutocompleteDisabled">                                 
    </ng-autocomplete>
    <ng-template #itemTemplate let-item>
      <a style="padding: 8px 15px;" class="f-s-12 p-10" [innerHTML]="item.description"></a>
    </ng-template>   
    <ng-template #notFoundTemplate let-notFound>
      <p style="padding-top: 5px;
      margin-bottom: 5px;
      font-weight: 500;" *ngIf="isTypedSearch">No se encontraron registros</p>
    </ng-template>
</div>
